import React from 'react'
import {connect} from 'react-redux'
import { bindActionCreators } from 'redux'
import qs from 'qs'
import { getToken, storage, urlQuerySet, urlQueryGet, getAccessToken } from '../utils'
import Config, {prodConfig} from '../config'
import lodash from 'lodash'
import EventBus from '../utils/bus'
import axios from 'axios'

import {Preload, Page, FollowLiveroom, SubscribeLecture,
    VideoPlayer, NetworkDelay, ImagePreviewer} from '../components'
import { MedalModal } from '../components/medal'
import Pay from '../components/Pay'
import * as liveroomAction from '../actions/liveroom'

import {
    ClassroomTopNotify,
    ClassroomShareRank,
    ClassroomOptions,
    ClassroomToolBar,
    ClassroomTopBar,
    ClassroomDiscussArea,
    ClassroomCountDown,
    ClassroomNewbieTips,
    ClassroomControlBar,
    ClassroomDiscussBar,
    ClassroomMaterialPanel,
    ClassroomCardPanel,
    ClassroomReward,
    ClassroomDiscussPanel,
    ClassroomTextareaPanel,
    ClassroomPPTMaterialPanel,
    ClassroomCheckIn,
    ClassroomRedpackPanel,
    ClassroomRedpackGrabDialog,
    ClassroomRedpackUserDialog,
    ClassroomCheckInDialog,
    ClassroomChatroom,
    ClassroomNoSleepVideo,
    ClassroomMessageList,
    ClassroomNoListenDialog,
    ClassroomCloseUp,
    ClassroomDiscussRobot,
    ClassroomBottomAnimation,
    ClassroomFilePanel,
    ClassroomChannelLecturesPopup,
} from '../components/classroom'
import {UploadQueue} from '../components'
import {WKEvaluation} from '../components/wk'
import '../styles/Classroom.css'
import error_image from '../images/404.jpg'
import {noVideoWhiteList} from '../no-video-white-list'
import { isChannelCPS } from '../utils/cps'

class ClassroomPage extends React.Component {
    getChildContext() {
        return {classroomPage: this};
    }

    constructor() {
        super()
        this.lazyLoads = [];
        this.lastScrollTop = 0;
        this.stat_online = null;
        this.state = {
            initialized: false,
        }
        this.onScroll = this.onScroll.bind(this)
        this.onTouchStart = this.onTouchStart.bind(this)
    }

    onOpenOptions() {
        this.page.hideMenu()
        this.props.dispatch({
            type: 'CLASSROOM_SHOW_OPTIONS'
        })
    }

    getComplain() {
        this.page.hideMenu()
        const {lecture} = this.props.classroom
        window.location = `/complain/lecture/${lecture.id}`;
    }

    gotoChannel(){
        this.page.hideMenu()
        const {channel} = this.props.classroom
        window.location = `/channel/${channel.id}`;
    }

    gotoLecture() {
        this.page.hideMenu()
        const {lecture} = this.props.classroom
        window.location = `/lecture/${lecture.id}`
    }

    gotoHomePage() {
        this.page.hideMenu()
        const {liveroom} = this.props.classroom
        window.location = `/liveroom/${liveroom.id}`
    }

    gotoMyPage() {
        this.page.hideMenu()
        window.location = `/account/`
    }

    setPlaybackRate(rate) {
        this.page.hideMenu()

        const au = document.getElementById('player_audio')
        au.defaultPlaybackRate = rate
        au.playbackRate = rate

        const playbackRate = rate.toFixed(1);
        sessionStorage.setItem('playbackRate', playbackRate)
        this.props.dispatch({
            type: 'AUDIO_SET_PLAYBACK_RATE',
            payload: playbackRate
        })
    }

    onSetPlaybackRate() {
        const menus = [
            {
                label: '0.7倍速',
                onClick: e => this.setPlaybackRate(0.7)
            },
            {
                label: '正常倍速',
                onClick: e => this.setPlaybackRate(1.0)
            },
            {
                label: '1.5倍速',
                onClick: e => this.setPlaybackRate(1.5)
            },
            {
                label: '2.0倍速',
                onClick: e => this.setPlaybackRate(2.0)
            },
            {
                label: '2.5倍速',
                onClick: e => this.setPlaybackRate(2.5)
            },
            {
                label: '3.0倍速',
                onClick: e => this.setPlaybackRate(3.0)
            }
        ]
        this.page.showMenu(menus)
    }

    onOpenUserMenu() {
        const {role, channel, liveroom} = this.props.classroom;
        let menus = [];
        if (role.is_lecturer) {
            menus.push({
                label: '课堂设置',
                onClick: this.onOpenOptions.bind(this)
            });
        }
        menus.push({
            label: '查看课程介绍',
            onClick: this.gotoLecture.bind(this)
        });
        if (channel) {
            menus.push({
                label: '专栏：' + channel.name,
                onClick: this.gotoChannel.bind(this)
            });
        }
        menus.push({
            label: '店铺：' + liveroom.name,
            onClick: this.gotoHomePage.bind(this)
        });
        menus.push({
            label: '个人中心',
            onClick: this.gotoMyPage.bind(this)
        });
        // 支付宝不添加下载app的入口
        if (window.platform !== 'alipay') {
            menus.push({
                label: '下载荔课APP',
                onClick: this.gotoAppPage.bind(this)
            });
        }
        menus.push({
            label: '投诉',
            onClick: this.getComplain.bind(this)
        });
        this.page.showMenu(menus)
    }

    checkLazyLoads(){
        this.afterScrollTimer && clearTimeout(this.afterScrollTimer)
        this.afterScrollTimer = setTimeout(()=>{
            if (!this.refs.page) return
            const page = this.refs.page.getBoundingClientRect()
            this.lazyLoads.map((v) => {
                if(v.el && v.el.getBoundingClientRect){
                    const rect = v.el.getBoundingClientRect()
                    if(rect.bottom > page.top && rect.top < screen.height){
                        v.onVisible()
                        v.deleted = true
                    }
                }else if(v.onScroll){
                    v.onScroll()
                }
                return null
            })
            this.lazyLoads = this.lazyLoads.filter((v) => (!v.deleted))
        }, 100)
    }

    onTouchStart() {
        this.refs.toolBar.showNavigation()
    }

    onScroll() {
        const {classroom, dispatch} = this.props;
        const scrollTop = this.refs.page.scrollTop;
        const lastScrollTop = this.lastScrollTop;
        this.lastScrollTop = scrollTop;

        if(!classroom.scrolling){
            // 手动滚动
            this.checkLazyLoads()
            return
        }

        // 以下为自动滚动代码
        if (lastScrollTop) {
            // 在滚动过程中，有人反方向操作，则停止滚动
            if ((scrollTop > lastScrollTop && classroom.currentPosition < scrollTop) ||
                (scrollTop < lastScrollTop && classroom.currentPosition > scrollTop)) {
                dispatch({
                    type: 'CLASSROOM_STOP_SCROLLING'
                })
                return;
            }
        }

        if (scrollTop !== classroom.currentPosition) {
            const dy = parseInt((classroom.currentPosition - scrollTop) / 5, 10);
            if (dy !== 0) {
                setTimeout(() => {
                    this.refs.page.scrollTop += dy;
                    if (this.refs.page.scrollTop === scrollTop) {
                        dispatch({
                            type: 'CLASSROOM_STOP_SCROLLING'
                        })
                        this.checkLazyLoads()
                    }
                }, 20);
                return;
            }
        }
        if (classroom.scrolling) {
            dispatch({
                type: 'CLASSROOM_STOP_SCROLLING'
            })
            this.checkLazyLoads()
        }
    }

    scrollToBottom(immediate) {
        this.scrollTo(this.refs.page.scrollHeight, immediate);
    }

    scrollToTop(immediate) {
        this.scrollTo(0, immediate);
    }

    scrollTo(pos, immediate) {
        const scrollTop = this.refs.page.scrollTop;
        this.lastScrollTop = scrollTop;

        pos -= this.refs.page.clientHeight - 180;
        pos = Math.min(pos, this.refs.page.scrollHeight + this.refs.page.clientHeight);
        pos = Math.max(pos, 0);

        if(!immediate) {
            if(navigator.userAgent.toLowerCase().indexOf('android') > -1){
                immediate = true
            }
        }

        if (immediate) {
            this.props.dispatch({
                type: 'CLASSROOM_SET_CURRENT_POSITION',
                payload: {
                    currentPosition: pos,
                    scrolling: false
                }
            })
            this.refs.page.scrollTop = pos;
            setTimeout(() => {
                this.checkLazyLoads()
            }, 100)
            return;
        }

        this.props.dispatch({
            type: 'CLASSROOM_SET_CURRENT_POSITION',
            payload: {
                currentPosition: pos,
                scrolling: true
            }
        })

        const dy = (pos - scrollTop) / 10;
        this.scrollTimer = setTimeout(() => {
            this.refs.page.scrollTop += dy;
        }, 20);
    }

    componentWillUnmount() {
        var {lecture_id} =  this.props.params
        this.scrollTimer && clearTimeout(this.scrollTimer);
        this.afterScrollTimer && clearTimeout(this.afterScrollTimer)
        this.stat_online && clearInterval(this.stat_online)
        document.title = ''

        let {classroom} = this.props;
        if (classroom.role.is_manager || classroom.role.is_lecturer) {
            axios.post(`/api/classroom/${lecture_id}/leave`).then((res) => {
            });
        }
    }

    onClickMedalClose () {
        this.props.dispatch({
            type: 'CLASSROOM_SET_IS_SHOW_MEDAL_MODAL',
            payload: false,
        })
    }

    renderClassroom() {
        const {classroom, ppt} = this.props;
        const {initialized} = this.state;
        if (classroom.error) {
            setTimeout( function(){window.location.href = '/'} , 3000)
            return(
                <div className="text-center weui-padding classroom-404">
                    <img src={error_image} alt="404"/>
                    <p>糟糕！访问的页面被外星人挟持啦～<br/>
                        {classroom.error}</p>
                    <p className="margin-top">秒速传送...</p>
                </div>
            )
        }

        if (!initialized) {
            return <div className="wk-inner-page main-page">
                <Preload />
            </div>
        }

        const hasTopVideo = classroom.lecture.image_mode === 'video'
        const hasTopAudio = classroom.lecture.image_mode === 'audio'
        const hasTopPPT = classroom.options.ppt_open
        const clientWidth = Math.min(480, window.innerWidth || screen.width)
        const videoHeight =  Math.ceil(clientWidth * 1080 / 1920)
        let classroomOffset = 40
        if(hasTopVideo && classroom.showTopVideo)
            classroomOffset += videoHeight
        if(hasTopAudio && classroom.showTopVideo)
            classroomOffset += videoHeight
        // 没有上传ppt的学员端不做处理
        if (!(ppt.ppts.length === 0 && !classroom.role.is_lecturer && !classroom.role.is_manager)) {
            if (hasTopPPT && classroom.showTopVideo) {
                classroomOffset += videoHeight
            }
        }
        let bottomOffset = 50
        if (classroom.reply) {
            bottomOffset += 36
        }

        const classroomStyles = {
            top: classroomOffset + 'px',
            bottom: bottomOffset + 'px'
        }

        const liveroomId = classroom.liveroom && classroom.liveroom.id

        return (
            <div style={{minHeight: (window.innerHeight || screen.height) + 'px', height: '100vh'}} className="classroomPage">
                <UploadQueue />
                {classroom.role.is_lecturer && <NetworkDelay /> }
                {!classroom.role.is_lecturer && <ClassroomNoSleepVideo /> }
                <Pay />
                <ClassroomChatroom />
                <VideoPlayer />
                <ImagePreviewer />
                <FollowLiveroom special="classroom" lecture_id={classroom.lecture.id}/>
                <SubscribeLecture />
                <ClassroomOptions />
                <ClassroomCheckIn />
                <ClassroomTopNotify />
                <ClassroomDiscussRobot />
                <ClassroomDiscussArea />
                <ClassroomCountDown />
                {!isChannelCPS() && <ClassroomCloseUp />}
                <ClassroomNoListenDialog />
                <ClassroomTopBar />
                <ClassroomMaterialPanel />
                <ClassroomCardPanel />
                <ClassroomReward />
                <ClassroomDiscussPanel />
                <ClassroomTextareaPanel />
                <ClassroomPPTMaterialPanel />
                <ClassroomRedpackPanel />
                <ClassroomFilePanel />
                <ClassroomRedpackGrabDialog />
                <ClassroomRedpackUserDialog />
                <ClassroomCheckInDialog />
                <ClassroomChannelLecturesPopup />
                <MedalModal
                    show={classroom.isShowMedalModal}
                    onClickClose={e => this.onClickMedalClose()}
                    isShowBtn={classroom.role.is_manager}
                    type={classroom.medalType}
                    liveroomId={liveroomId}
                />
                <ClassroomToolBar ref="toolBar" style={classroomStyles} />
                <div className="classroom-bg">
                    <div className="classroom-page" id="page" onScroll={this.onScroll} style={classroomStyles}
                        onTouchStart={this.onTouchStart}
                         ref="page">
                        <ClassroomNewbieTips />
                        {!isChannelCPS() && <ClassroomShareRank />}
                        <ClassroomMessageList ref="messageList"/>
                    </div>
                </div>
                {(classroom.role.is_lecturer ? <ClassroomControlBar /> : <ClassroomDiscussBar />)}

                {(!classroom.showCloseUpDialog && !classroom.role.is_lecturer && !classroom.role.is_manager && !this.props.account.subscribed && !isChannelCPS()) &&
                <ClassroomBottomAnimation
                    account={this.props.account}
                    role={this.props.classroom.role}
                    lecture={this.props.classroom.lecture}
                    liveroom={this.props.classroom.liveroom}
                    qrcodes={this.props.classroom.qrcodes}/>
                }
                { !classroom.role.is_lecturer &&
                !classroom.role.is_manager &&
                this.props.classroom.lecture.status === 'closed' &&
                    false &&
                <WKEvaluation account={this.props.account} lecture={this.props.classroom.lecture} isOnlyFirst={true} />
                }
            </div>
        )
    }

    fetchChannelLectures (channel) {
        if (!channel) {
            this.props.dispatch({
                type: 'CLASSROOM_SET_CHANNEL_LECTURES',
                payload: []
            })
            return
        }
        axios.get(`/api/channel/${channel.id}/lecture_list`)
            .then(res => {
                if (res.data.code === 0) {
                    this.props.dispatch({
                        type: 'CLASSROOM_SET_CHANNEL_LECTURES',
                        payload: res.data.data.lectures
                    })
                }
            })
    }

    componentDidMount() {
        let {lecture_id} =  this.props.params
        let ts = Date.now();
        let search = location.search ? `${location.search}&ts=${ts}` : `?ts=${ts}`

        // 校验是否有店铺
        this.props.checkHasLiveroom()


        // 判断是否为新版白名单
        // 0 liveroomid无所谓  传0就可以
        window.axiosAdmin.get(`/api/liverooms/0/lectures/${lecture_id}/query_new_class`, {
            params: { token: getAccessToken() }
        }).then(res => {
           const { data: { data, code } } = res
           if(code === 0 && data.is_white) {
              location.assign(`${Config.MAIN_URL}/classroom3/${lecture_id}/`)
           }
        })

        axios.get(`/api/classroom/${lecture_id}/info${search}`).then((response) => {
            if (response.data.code === 0) {
                let {data} = response.data



                this.fetchChannelLectures(data.channel)
                if (data.lecture.lecture_mode !== 'default' && data.lecture.lecture_mode !== 'live_video'){
                    window.location.href = `/lecture/${data.lecture.id}`
                }

                const { lecture, share_info } = data

                // 课程视频被误删的特例
                if (noVideoWhiteList[lecture_id]) {
                    const [file_id] = noVideoWhiteList[lecture_id]
                    if (data.lecture.qcloud_video_file_id === file_id) {
                        setTimeout(() => {
                            if (confirm('视频无法播放，详情请联系客服')) {
                                location.assign(`${prodConfig.MAIN_URL}/activity/servicepage/`)
                            }
                        }, 5e3)
                    }
                }

                if(Config.REDIRECT_WARN){
                    if(  data.role.is_lecturer && window.location.origin != Config.MAIN_URL){
                        window.location.href = Config.MAIN_URL + window.location.pathname + window.location.search
                    } else if( !data.role.is_lecturer && data.lecture.risk_level == 'warning' &&  window.location.origin != Config.WARNING_URL ){
                        let params = qs.parse(window.location.search.substr(1))
                        params.__token = getToken()
                        window.location.href =  Config.WARNING_URL + window.location.pathname  + '?' + qs.stringify(params)
                    }
                }

                if(data.liveroom.account_id === data.role.account_id){
                    data.role.is_fans = true
                }
                data.timestampDelta = (data.ts * 1000000 - Date.now() * 1000) / 1000000;
                this.props.dispatch({
                    type: 'CLASSROOM_INIT',
                    payload: data
                })
                this.setState({initialized: true});

                if (data.role.is_manager || data.role.is_lecturer) {
                    axios.post(`/api/classroom/${lecture_id}/join`).then((res) => {
                    });

                    //风控
                    this.page.showFengKongTip()
                }



                this.props.dispatch({
                    type: 'UPDATE_SHARE_DATA',
                    payload: {
                        title: share_info.share_title,
                        desc: share_info.share_description,
                        imgUrl: share_info.share_icon,
                        type: share_info.share_type,
                        dataUrl: share_info.share_data_url,
                        link: share_info.share_url,
                        objectType: 'lecture',
                        objectId: lecture.id,
                        objectMeta: 'classroom',
                    }
                });
                document.title = lecture.name

                try {
                    axios.get('/api/account/is_subscribed_retain').then((res) => {
                        if (res.data.code === 0) {
                           const subscribed_retain = res.data.data.subscribed_retain
                           EventBus.emit('subscribed_retainInfo', subscribed_retain)
                        }
                    })
                } catch (err) {
                    console.log(err)
                }

                const { classroom } = this.props
                if(!this.stat_online){
                    let f = () => {
                        const medias =
                            Array.from(document.getElementsByTagName('audio') || [])
                                .concat(Array.from(document.getElementsByTagName('video') || []))

                        const needEmit = medias.reduce((prev, curr) => (curr.id !== 'no-sleep-video' && !curr.paused) || prev, false)

                        if (needEmit) {
                            this.props.dispatch({
                                type: 'STATS_LOG',
                                payload: {
                                    action: 'classroom_stat_online',
                                    ts: new Date().getTime(),
                                    lecture_id: lecture.id
                                }
                            })
                        }
                    }
                    this.stat_online = setInterval(f, 60000)
                }
                if (data.channel) {
                    storage.setItem(`wk-intoclass-${data.channel.id}`, `${lecture_id}-live`);
                }

            } else {
                this.props.dispatch({
                    type: 'CLASSROOM_SET_ERROR',
                    payload: response.data.msg
                })
            }
        }).catch((error) => {
            if (error.response && error.response.status === 403) {
                window.location = '/lecture/' + lecture_id
                return
            }
            this.props.dispatch({
                type: 'CLASSROOM_SET_ERROR',
                payload: error.toString() + '稍后再试试吧'
            })
        })
    }

    componentDidUpdate() {
        // 拦截没有绑定手机的管理员，不允许讲课
        const {account, classroom} = this.props
        if (classroom && classroom.role.is_manager
            && account && !account.telephone_validate && !classroom.liveroom.is_pass
            && !this._unvalidatedAlertIsShow) {

            // 如果老师没有绑定手机号，强制刷新一次试试看能不能解决
            if (!urlQueryGet(location.href, '_t')) {
                location.replace(urlQuerySet(location.href, '_t', Date.now()))
            } else {
                this._unvalidatedAlertIsShow = true
                this.page.showUnBindPhone()
            }
        }
    }


    render() {
        return (
            <Page parent={this}>
                {this.renderClassroom()}
            </Page>
        )
    }

}


ClassroomPage.childContextTypes = {
    classroomPage: React.PropTypes.object
};


export default connect(state => ({
    classroom: state.classroom,
    ppt: state.ppt,
    wechat: state.wechat,
    account: state.account,
}), dispatch => bindActionCreators({ ...liveroomAction, dispatch}, dispatch))(ClassroomPage)



// WEBPACK FOOTER //
// ./src/pages/ClassroomPage.js